import styled from '@emotion/styled';
import React from 'react';
import { Magnetic as Mi } from "../../styles/Semantic";
import { UAM_STYLES } from "../uam/constants";
const StyledAssistanceModalBody = styled('div') `
	display: flex;
	flex-shrink: 0;
	font-family: ${Mi.baseFontFamily};
	font-size: ${Mi.baseFontSize};
	padding: ${Mi.assistanceModalBodyPadding};
	padding-top: ${props => props.shouldHideClose
    ? /* Temporary ignored */
        /*istanbul ignore next*/
        Mi.spacer20
    : '0'};
`;
const StyledIcon = styled('div')(({ type }) => `
	display: flex;
	flex: 0 0 auto;
	align-self: flex-start;
	color: ${UAM_STYLES.get(type).color};
	font-size: ${Mi.assistanceModalIconSize};
	margin-right: ${Mi.assistanceModalIconMarginRight};
`);
const StyledBlockUamContentDiv = styled('div') `
	flex: 1 1 auto;
	white-space: normal;
	flex-wrap: wrap;
`;
const StyledBlockTitle = styled('div') `
	font-size: ${Mi.assistanceModalTitleFontSize};
	font-weight: ${Mi.assistanceModalTitleFontWeight};
	margin-bottom: ${Mi.assistanceModalTitleMarginBottom};
`;
/**
 * Props for AssistanceModal component
 * @param {UamType} type to determines iconClass and color
 * @param {string} title title of the modal
 * @param {string} customIcon  to override the default icon associated with the user assistance type
 * @param {ReactNode | string} children the content the component wraps
 */
export const AssistanceModalBody = props => {
    const { title, type, customIcon, children, shouldHideClose } = props;
    return (React.createElement(StyledAssistanceModalBody, { shouldHideClose: shouldHideClose },
        React.createElement(StyledIcon, { className: "block-icon", type: type },
            React.createElement("span", { className: customIcon || UAM_STYLES.get(type).icon })),
        React.createElement(StyledBlockUamContentDiv, null,
            title && React.createElement(StyledBlockTitle, { className: "block-title" }, title),
            children)));
};
//# sourceMappingURL=AssistanceModalBody.js.map